export default __webpack_public_path__ + "2aa61284ffcb5916a41129e8c2e1243c.png";